export const defaultVadParams = {
  startOnLoad: false,
  positiveSpeechThreshold: 0.9, // determines the threshold over which a probability is considered to indicate the presence of speech.
  negativeSpeechThreshold: 0.1, // determines the threshold under which a probability is considered to indicate the absence of speech.
  redemptionFrames: 5, // number of speech-negative frames to wait before ending a speech segment.
  minSpeechFrame: 5, // minimum number of speech-positive frames for a speech segment.
  preSpeechPadFrames: 5, // number of audio frames to prepend to a speech segment.
};
